import React from 'react';

import DynamicSubLayout, {
	IProps as DSLprops,
} from 'core/components/DynamicSubLayout';

import * as S from './CtaContainer.style';

interface IProps extends DSLprops {
	margin?: string;
	/* Whether to stretch the Cta to full-width when stacked responsively. */
	disableFullWidth?: boolean;
	direction?: string;
	children: React.ReactNode;
}

const STACK_AT = 'xxs';

const CtaContainer = ({
	children,
	margin,
	direction = 'row',
	disableFullWidth = false,
	...props
}: IProps) => (
	<S.CtaContainer {...{ margin, disableFullWidth }}>
		<DynamicSubLayout
			stackAt={STACK_AT}
			gap={12}
			align="left"
			layout="auto"
			direction={direction}
			{...props}
		>
			{children}
		</DynamicSubLayout>
	</S.CtaContainer>
);

CtaContainer.defaultProps = {
	margin: '12px 0 0 0',
};

export default CtaContainer;
